$(document).ready(function () {
  var t = $(".downloadSlickslider");
  t.slick({
    dots: !1,
    swipe: !1,
    infinite: !0,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: !0,
  }),
    $(".sliderDots span").on("click", function () {
      var i = $(this).parent().index();
      t.slick("slickGoTo", i);
    }),
    t.on("afterChange", function (t, i, e) {
      $(".sliderDots li").removeClass("active"),
        $(".sliderDots li").eq(e).addClass("active");
    });
});
